<template>
    <div class="">
        <ul class="nav nav-tabs bg-primary pt-2 px-1">
            <li class="nav-item" v-for="(tab, i) in tabs">
                <a
                    class="font-weight-bold text-primary"
                    :id="`tab-${i}`"
                    :class="
                        filter === i ? 'nav-link active' : 'btn btn-sm btn-outline m-1 bg-white'
                    "
                    @click="setParentProp(filterName, i)"
                    >{{ tab }}</a
                >
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "Tabs",
    props: {
        filter: {
            type: Number,
            required: true,
        },
        filterName: {
            type: String,
            default: "filter",
        },
        tabs: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style scoped></style>
